// extracted by mini-css-extract-plugin
export var label = "_gu-2";
export var slideContainer = "_gu-0";
export var slider = "_gu-1";